import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GridOptions } from 'ag-grid-community';
import { SettingsService } from '../../../../core/settings/settings.service';
import { CeqTableComponent } from '../../../common/ceq-table/ceq-table.component';
import { DeleteChildRendered } from '../../../common/renders/delete-child-rendered';
import { EditChildRendered } from '../../../common/renders/edit-child-rendered';
import { CurrencyService } from '../currency.service';
import * as moment from 'moment';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-currency-list',
  templateUrl: './currency-list.component.html',
  styleUrls: ['./currency-list.component.scss']
})
export class CurrencyListComponent implements OnInit {
  @ViewChild('CeqGrid', { static: false }) ceqGrid: CeqTableComponent;

  options: GridOptions;
  PageSizes = [10, 25, 50, 100, 1000];

  org: number;

  gridOptions = {
    context: this,
    frameworkComponents: {
      childEditRenderer: EditChildRendered,
      childDeleteMessageRenderer: DeleteChildRendered
    },
    suppressHorizontalScroll: true,
    onRowDoubleClicked(event: any) { },
    icons: {
      sortAscending: '<i class="fa fa-sort-up" style="margin-left:10px"></i>',
      sortDescending: '<i class="fa fa-sort-down" style="margin-left:10px"></i>',
      sortUnSort: '<i class="fa fa-sort" style="margin-left:10px"></i>'
    }
  }

  columnDefs = [
    {
      headerName: 'Código',
      field: 'currencyCode',
      width: 3,
      cellClass: 'align-start',
      sortable: true,
      unSortIcon: true,
      resizable: true,
      editable: false
    },
    {
      headerName: 'Nombre',
      field: 'currencyName',
      width: 50,
      cellClass: 'align-start',
      sortable: true,
      unSortIcon: true,
      resizable: true,
      editable: false
    },
    {
      headerName: 'Última modificación',
      field: 'ModifiedAt',
      width: 20,
      cellClass: 'align-start',
      sortable: true,
      unSortIcon: true,
      resizable: true,
      editable: false,
      cellRenderer: (params: any) => moment(params.data.ModifiedAt).format('YYYY-MM-DD HH:mm:ss')
    },
    {
      headerName: 'Modificado por',
      field: 'ModifiedBy',
      width: 20,
      cellClass: 'align-start',
      resizable: true,
      editable: false
    },
    {
      headerName: 'Editar',
      field: 'icon',
      width: 10,
      cellRenderer: 'childEditRenderer',
      colId: 'params',
      cellClass: 'text-center',
      resizable: true,
      hide: false,
    },
    {
      headerName: 'Eliminar',
      field: 'icon',
      width: 10,
      cellRenderer: 'childDeleteMessageRenderer',
      colId: 'params',
      cellClass: 'text-center',
      resizable: true,
      hide: false,
    }
  ];

  constructor(private currencyService: CurrencyService, private globalFunctionService: GlobalFunctionsService, private settings: SettingsService, private router: Router) { }

  ngOnInit(): void {
    this.org = this.settings.getUser().Org;
  }

  gridEmiter(GridOptions: GridOptions) {
    this.options = GridOptions;
    this.getCurrency();
  }

  onPageSizeChange(value: number) {
    console.log(value);
  }

  btnAddClick() {
    this.router.navigate(['/tax/currency/create']);
    this.getCurrency();
  }

  edit(row: any) {
    this.router.navigate([`/tax/currency/${row.data.currencyId}`]);
    this.getCurrency();
  }

  async delete(row: any) {
	  const result = await this.globalFunctionService.messageBimbo("¿Desea eliminar la moneda " + row.data.currencyCode + "?", 'question1', 'Confirmacion');
      if (result) {
        console.log("row: " + row.data.currencyId);
        this.currencyService.deleteCurrency(row.data.currencyId).subscribe(async data => {
          console.log("result", data);
		      await this.globalFunctionService.messageBimbo('La configuración se eliminó correctamente.', 'success', '¡Éxito!');
        }, async (error) => {
          console.log("error", error);
		      await this.globalFunctionService.messageBimbo(error.error, 'error', '¡Error!');
        }, () => {
          this.getCurrency();
        });
      }
  }

  getCurrency() {
    this.currencyService.getCurencyList().subscribe(data => {
      this.ceqGrid.data = data;
    });
  }
}
